import React, { useState, useEffect } from 'react';
import { fetchHeroImages, subscribeToHeroImagesUpdates } from '../../../services/siteSettingsService';

const BackgroundSlideshow = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [heroImages, setHeroImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch hero images
    const loadHeroImages = async () => {
      const images = await fetchHeroImages();
      setHeroImages(images);
      setIsLoading(false);
    };

    loadHeroImages();

    // Subscribe to real-time updates
    const unsubscribe = subscribeToHeroImagesUpdates((updatedImages) => {
      setHeroImages(updatedImages);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (heroImages?.length === 0) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages?.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages?.length]);

  if (isLoading || heroImages?.length === 0) {
    return (
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-background to-pink-900"></div>);

  }

  const imagesToDisplay = heroImages?.length > 0 ? heroImages : [
  {
    url: "https://images.unsplash.com/photo-1615414046707-3d7d91938aa4",
    alt: 'Historic theater stage with ornate curtains and classical architecture'
  }];


  return (
    <div className="absolute inset-0 overflow-hidden">
      {imagesToDisplay?.map((image, index) =>
      <div
        key={heroImages?.length > 0 ? image?.id : index}
        className={`absolute inset-0 transition-opacity duration-1000 ${
        index === currentImageIndex ? 'opacity-100' : 'opacity-0'}`
        }
        style={{
          backgroundImage: `url(${heroImages?.length > 0 ? image?.image_url : image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>

          <div className="absolute inset-0 bg-gradient-to-b from-purple-900/70 via-purple-900/60 to-purple-900/70" />
        </div>
      )}
    </div>);

};

export default BackgroundSlideshow;